import { type RootState } from '../../stores/redux';

export const getFileTransferState = (state: RootState) =>
  state.filetransfer.currentState;

export const getRequestMemberIds = (state: RootState) =>
  state.filetransfer.requestMemberIds;

export const getFileTransferSessionId = (state: RootState) =>
  state.filetransfer.fileTransferSessionId;

export const getFileTransferFilesAvailable = (state: RootState) =>
  state.filetransfer.filesAvailable;

export const getFileTransferFilesUploaded = (state: RootState) =>
  state.filetransfer.filesUploaded;

export const getFileTransferUploadingFilesCount = (state: RootState) =>
  state.filetransfer.uploadingFilesCount;
